import { useQuery } from "@tanstack/react-query";
import { supabase } from "../../../lib/supabase";

export interface StarterRow {
  id: string;
  agent_id: string | null;
  template_key: string | null;
  kicker: string | null;
  title: string;
  description: string | null;
  prompt: string;
  sort_order: number;
  active: boolean;
}

export function useStarterPrompts(agentId: string | null) {
  return useQuery({
    queryKey: ["agent_starters", agentId],
    enabled: !!agentId,
    queryFn: async (): Promise<StarterRow[]> => {
      if (!agentId) return [];
      const { data, error } = await supabase
        .from("agent_starters_view")
        .select("*")
        .eq("active", true)
        .eq("agent_id", agentId)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data ?? []) as StarterRow[];
    },
    staleTime: 5 * 60_000,
  });
}
